import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getSubLessonsByLesson } from "../../../services/SubLesson";
import { TitleBar } from "../../../components/TitleBar";
import { EditLessonSideBar } from "../../../components/EditLessonSideBar";
import { getLessonsByCourse } from "../../../services/Lesson";
import { SubLesson } from "../../../components/SubLesson";
import { AddLesson } from "../../../components/AddLesson";
import { EditLesson } from "../../../components/EditLesson";
import { AddSubLesson } from "../../../components/AddSubLesson";
import { EditSubLesson } from "../../../components/EditSubLesson";
import DeletePopup from "../../../components/DeletePopup";
import { ConfirmPopup } from "../../../components/ConfirmPopup";

export const UpdateCourse = () => {
    const location = useLocation();
    const { id, title } = location.state || {};
    const [allLessons, setAllLessons] = useState<any[]>([]);
    const [showEditLessonPopup, setShowEditLessonPopup] = useState<boolean>(false);
    const [editLesson, setEditLesson] = useState<any>({});
    const [selectedLessonId, setSelectedLessonId] = useState<number | null>(null);
    const [refreshLessonList, setRefreshLessonList] = useState<boolean>(true);
    const [lessonDataLoaded, setLessonDataLoaded] = useState<boolean>(false);
    const [showAddLessonPopup, setShowAddLessonPopup] = useState<boolean>(false);
    const [subLessons, setSubLessons] = useState<any[]>([]);
    const [subLessonLoaded, setSubLessonLoaded] = useState<boolean>(false);
    const [showAddSubLessonPopup, setShowAddSubLessonPopup] = useState<boolean>(false);
    const [showEditSubLessonPopup, setShowEditSubLessonPopup] = useState<boolean>(false);
    const [editSubLesson, setEditSubLesson] = useState<any>({});
    const [refreshSubLessonList, setRefreshSubLessonList] = useState<boolean>(true);

    useEffect(() => {
        if (id && refreshLessonList) {
            getLessonsByCourse(id)
                .then((data) => {
                    setAllLessons(data);
                    setSelectedLessonId(data[0]?.id)
                    setLessonDataLoaded(true);
                    setRefreshLessonList(false);
                    setRefreshSubLessonList(true);
                    setEditLesson({});
                })
                .catch((error) => {
                    console.error(error)
                })
        }
    }, [refreshLessonList, id]);


    useEffect(() => {
        if (selectedLessonId && refreshSubLessonList) {
            setSubLessonLoaded(false);
            getSubLessonsByLesson(selectedLessonId)
                .then((data) => {
                    setSubLessons(data);
                    setSubLessonLoaded(true);
                    setRefreshSubLessonList(false);
                    setEditSubLesson({});
                })
                .catch((error) => {
                    console.error(error)
                })
        }
    }, [selectedLessonId, refreshSubLessonList]);


    return (
        <>
            <div className="p-4 min-h-80 bg-white rounded-md">
                <TitleBar
                    title={title}
                    subTitle={`${allLessons.length} Lessons`}
                    isBackTo={true}
                    backPath="/admin/courses"
                    backToTitle="Back to Course"
                />

                <div className="w-full py-8">
                    {
                        allLessons.length > 0 && (
                            <div className="md:flex mt-4 border-t border-[#D0D0D0]">
                                <EditLessonSideBar
                                    lessonList={allLessons}
                                    selectedLessonId={selectedLessonId}
                                    onSelectLesson={(lessonId: number) => {
                                        if (lessonId !== selectedLessonId) {
                                            setSelectedLessonId(lessonId);
                                            setRefreshSubLessonList(true);
                                            setSubLessons([]);
                                        }
                                    }}
                                    setShowAddLessonPopup={setShowAddLessonPopup}
                                    setShowEditLessonPopup={setShowEditLessonPopup}
                                    setEditLesson={setEditLesson}
                                    setRefreshLessonList={setRefreshLessonList}
                                />


                                <div className="w-full bg-slate-100 p-4">
                                    {
                                        (subLessonLoaded && subLessons.length > 0) && (
                                            <div>
                                                <div className="w-full mt-4 mb-4 flex justify-end items-center pb-4 bg-transparent">
                                                    <button
                                                        className="py-2 px-4 bg-primary text-white text-sm font-medium rounded-md outline-none hover:bg-blue-600 shadow-md"
                                                        onClick={() => setShowAddSubLessonPopup(true)}
                                                    >
                                                        Add sub-lesson
                                                    </button>
                                                </div>

                                                {
                                                    subLessons.map((item: any, index: number) => (
                                                        <SubLesson key={index} data={item} setEditSubLesson={setEditSubLesson} setRefreshSubLessonList={setRefreshSubLessonList} setShowEditSubLessonPopup={setShowEditSubLessonPopup} />
                                                    ))
                                                }
                                            </div>

                                        )
                                    }

                                    {
                                        !subLessonLoaded && (
                                            <div className="flex items-center justify-center w-full p-2">
                                                <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                                            </div>
                                        )
                                    }


                                    {
                                        (subLessonLoaded && subLessons.length === 0) && (

                                            <div
                                                className="w-full bg-white border py-10 rounded-xl flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50 transition"
                                                onClick={() => setShowAddSubLessonPopup(true)}
                                            >
                                                <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center mb-2">
                                                    <span className="material-symbols-outlined text-3xl text-white">
                                                        add
                                                    </span>
                                                </div>
                                                <p className="text-gray-600 font-medium text-sm">
                                                    Add Sub-Lesson
                                                </p>
                                            </div>

                                        )
                                    }




                                </div>
                            </div>
                        )
                    }


                    {
                        !lessonDataLoaded && (
                            <div className="flex items-center justify-center w-full p-2">
                                <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary" />
                            </div>
                        )
                    }

                    {
                        (lessonDataLoaded && allLessons.length === 0) && (

                            <div
                                className="w-full bg-blue-50 border border-blue-200 py-10 rounded-xl flex flex-col items-center justify-center cursor-pointer hover:bg-blue-100 transition"
                                onClick={() => setShowAddLessonPopup(true)}
                            >
                                <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center mb-2">
                                    <span className="material-symbols-outlined text-3xl text-white">
                                        add
                                    </span>
                                </div>
                                <p className="text-gray-600 font-medium text-sm">
                                    Add Lesson
                                </p>
                            </div>

                        )
                    }
                </div>
            </div>

            {
                showAddLessonPopup && (
                    <AddLesson showPopup={showAddLessonPopup} setShowPopup={setShowAddLessonPopup} setRefreshLessonList={setRefreshLessonList} courseId={id} />
                )
            }

            {
                showEditLessonPopup && (
                    <EditLesson showPopup={showEditLessonPopup} setShowPopup={setShowEditLessonPopup} setRefreshLessonList={setRefreshLessonList} data={editLesson} />
                )
            }

            {
                showAddSubLessonPopup && (
                    <AddSubLesson showPopup={showAddSubLessonPopup} setShowPopup={setShowAddSubLessonPopup} setRefreshSubLessonList={setRefreshSubLessonList} selectedLessonId={selectedLessonId} />
                )
            }

            {
                showEditSubLessonPopup && (
                    <EditSubLesson showPopup={showEditSubLessonPopup} setShowPopup={setShowEditSubLessonPopup} setRefreshSubLessonList={setRefreshSubLessonList} data={editSubLesson} />
                )
            }

            <DeletePopup />
            <ConfirmPopup />
        </>
    )
}